export const DECLARED = 10;
export const ACTIVE = 20;
export const UPDATING = 30;
export const REMOVING = 40;
export const REMOVE = 50;
export const TURNING_ON = 60;
export const TURNING_OFF = 70;
export const INACTIVE = 80;
